import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const TabItem = ({to, embed, small, accented, uppercaseClass, text, mobile}) => {
  return (
    <NavLink
      exact
      to={to}
      className={`cursor-pointer flex border-primary ${mobile ? `py-3 px-5 text-center` : `pb-4 mr-12`} opacity-50`}
      activeClassName="border-b-2 lg:border-b-4 opacity-100"
    >
      <p className={`font-bold text-center lg:text-left ${embed ? 'text-xs' : 'text-sm'} ${small ? 'lg:text-sm' : 'lg:text-base'} ${accented} ${uppercaseClass}`}>
        {text}
      </p>
    </NavLink>
  )
}

const ContentNav = ({organization, className, mobile}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  const routes = [
    {
      label: translation.PROGRAM.singular[language.name],
      route: '/program',
      collection: 'programs'
    },
    {
      label: translation.EVENT.singular[language.name],
      route: '/event',
      collection: 'events'
    },
    {
      label: translation.RESOURCE.singular[language.name],
      route: '/resource',
      collection: 'resources'
    },
    {
      label: translation.BLOG.singular[language.name],
      route: '/blog',
      collection: 'blogs'
    },
    {
      label: 'Member',
      route: '/member'
    },
  ]

  return (
    <div className={`flex overflow-x-auto ${className}`}>
      <TabItem
        text={translation.NAVIGATION.about[language.name]}
        mobile={mobile}
        accent
        uppercase
        to={`/organization/${organization.id}`}
      />
      {
        routes.map((r, index) => (
          <TabItem
            key={index}
            text={r.label}
            mobile={mobile}
            accent
            uppercase
            to={
              r.collection ? `/organization/${organization.id}${r.route}?collection=${r.collection}&organization=${organization.id}`
              : `/organization/${organization.id}${r.route}`
            }
          />
        ))
      }

      {/* Linear gradient overlay filler */}
      <div style={{minWidth: '100px'}}></div>
    </div>
  )
}

export { ContentNav }
